<div class="unit-details-inspections-section-container" *ngIf="inspectionsSource?.data?.length > 0; else noInspections">
  <div class="inspections-table-container">
    <table
      mat-table
      [dataSource]="inspectionsSource"
      matSort
      [matSortActive]="sortActive"
      [matSortDirection]="sortDirection"
    >
      <ng-container matColumnDef="turboMode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">Turbo</th>
        <td mat-cell *matCellDef="let inspection">
          <app-icon
            *ngIf="inspection.entityDetails.isTurboMode"
            [svg]="EIcon.TURBO"
            [iconHeight]="24"
            [iconWidth]="24"
          ></app-icon>
        </td>
      </ng-container>
      <ng-container matColumnDef="inspectionType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">Type</th>
        <td mat-cell *matCellDef="let inspection">
          {{ inspection.inspectionTemplate?.name ?? inspection.inspectionType }}
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">Status</th>
        <td mat-cell *matCellDef="let inspection">
          <span class="status {{ InspectionStatus[inspection.entityDetails.status] }}-enum">
            {{ inspection.status }}
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="rooms">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true" class="centered-column">Spaces</th>
        <td mat-cell *matCellDef="let inspection" class="centered-column">{{ inspection.areasLabel }}</td>
      </ng-container>
      <ng-container matColumnDef="dueDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">Due</th>
        <td mat-cell *matCellDef="let inspection">
          {{ inspection.entityDetails.dueDate | date: 'MM/dd/yy' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="completedAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">Completed</th>
        <td mat-cell *matCellDef="let inspection">
          {{ inspection.entityDetails.completedAt | date: 'MM/dd/yy' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="assignee">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">Assignee</th>
        <td mat-cell *matCellDef="let inspection">{{ inspection.entityDetails.assigneeUser?.displayName }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let inspection">
          <button
            mat-icon-button
            aria-label="Actions"
            [matMenuTriggerFor]="actionsMenu"
            #menuTrigger="matMenuTrigger"
            [matMenuTriggerData]="{ inspection }"
            (click)="$event.stopPropagation()"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="header-small"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{
          completed: row.entityDetails.status === InspectionStatus.Completed
        }"
        (click)="open(row)"
      ></tr>
    </table>
    <mat-menu #actionsMenu="matMenu" class="menu-with-backdrop">
      <ng-template matMenuContent let-inspection="inspection">
        <button mat-menu-item (click)="download(inspection)">Download</button>
        <button mat-menu-item (click)="share(inspection)">Share</button>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="deleteInspection(inspection)">Delete</button>
      </ng-template>
    </mat-menu>
  </div>
</div>

<ng-template #noInspections>
  <span class="fs s14 display-flex align-items-center">No inspections. Go have a look! 🔎</span>
</ng-template>
